/*
 * File: useApplicationService.ts
 * Project: papa-bear
 * -----
 * Last Modified: 15 Nov 2021 2:13:28 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApplicationModel } from 'models/ApplicationModel';
import { ReduxState } from 'redux/rootReducer';

/* ****************** Interfaces ****************** */

/* ****************** Variables ****************** */
const freddyCadabbyBaseURL = process.env.REACT_APP_FREDDY_CADABBY_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_FREDDY_CADABBY;

const baseQuery = fetchBaseQuery({
  baseUrl: freddyCadabbyBaseURL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as ReduxState).app.accessToken;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      headers.set('x-functions-key', functionsKey);
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
});

export const applicationApi = createApi({
  reducerPath: 'applicationApi',
  baseQuery,
  endpoints: (builder) => ({
    getApplicationById: builder.query<ApplicationModel, string>({
      query: (id) => `applications/${id}`,
      transformResponse: (response: ApplicationModel) => ({
        accessPermissionName: response.accessPermissionName,
        id: response.id,
        description: response.description,
        name: response.name,
        url: response.url
      })
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetApplicationByIdQuery, useGetVersionQuery, useGetApiNameQuery } = applicationApi;
